const procedureHistoryReducer = (
  state = {
    loading: false,
    assetsLoading: false,
    exportLoading: false,
    data: null,
    total: null
  },
  action
) => {
  switch (action.type) {
    case "SET_PROCEDURE_HISTORY_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_PROCEDURE_HISTORY_ASSETS_LOADING":
      return {
        ...state,
        assetsLoading: action.payload.loading
      };

    case "SET_PROCEDURE_HISTORY_COUNT":
      return {
        ...state,
        total: action.payload.count
      };

    case "SET_PROCEDURE_HISTORY_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default procedureHistoryReducer;
